<template>
	<div class="h-100" style="">
		<widget-grid-layout />
		<div v-if="showCoachMark_">
			<coach-mark />
		</div>
		<div v-else class="widget add-widget-button" @click="toggleWidgetSide">
			<span class="sf-icon icon-sf-plus"></span>
		</div>
	</div>
</template>

<script>
import WidgetGridLayout from './WidgetGridLayout.vue';
import { serviceComputed, serviceMethods } from '@common/Widget/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import CoachMark from './coachMark/CoachMark.vue';

export default {
	components: { WidgetGridLayout, CoachMark },
	methods: {
		...serviceMethods,
		...rootMethods,
		toggleWidgetSide() {
			this.$store.commit('widgetStore/toggleWidgetSideBar', true);
		}
	},
	computed: {
		...serviceComputed,
		...rootComputed
	}
};
</script>

<style></style>
